<template>
  <div>
    <main>
      <HeroSection />
      <section class="my-4">
        <div class="grid-container">
          <EpomAd tag-style="relative" :placement-id="epomPlacementId" class="col-span-12" />

          <div class="col-span-12 tablet:col-span-9">
            <DataFetcher :is-loading="loading">
              <ul class="space-y-3">
                <NewsletterSignup v-if="!jobs.length" audience="omr-jobs-jobanzeigen" :title="$t('newsletter.jobs.title')" />

                <div v-for="(job, index) in jobs" :key="index">
                  <JobListItem :job="job" />

                  <NewsletterSignup
                    v-if="index === newsletterSignupIndex"
                    :key="'newsletterSignup_' + index"
                    audience="omr-jobs-jobanzeigen"
                    :title="$t('newsletter.jobs.title')"
                  />
                </div>
              </ul>

              <JobListPagination :page="page" :per-page="perPage" :total="jobCount" />
            </DataFetcher>
          </div>

          <div class="col-span-12 tablet:col-span-3">
            <JobListSidebar
              :category-facets="categoryFacets"
              :location-facets="locationFacets"
              :experience-facets="experienceFacets"
              :location-option-facets="locationOptionFacets"
            />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { EpomAd } from '@ramp106/omrjs-core-ui'
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import DataFetcher from '@/components/common/DataFetcher.vue'
import HeroSection from '@/components/HeroSection.vue'
import NewsletterSignup from '@/components/JobBoard/NewsletterSignup.vue'
import JobListItem from '@/components/JobListItem.vue'
import JobListPagination from '@/components/JobListPagination.vue'
import JobListSidebar from '@/components/JobListSidebar.vue'
import { useEpomPlacementId } from '@/composables'

import { useLazyAsyncData } from '#imports'
import { useSelectedFacetFiltersFromQuery } from '~/composables/useSelectedFacetFiltersFromQuery'
import { useJobsSdk } from '~/gql'

const route = useRoute()
const { searchJobs } = useJobsSdk()

const { selectedFacetFiltersFromQuery } = useSelectedFacetFiltersFromQuery()

const epomPlacementId = useEpomPlacementId()

const page = computed(() => parseInt(route.params.page as string, 10) || 1)
const jobCount = computed(() => data.value?.jobCount || 0)
const perPage = ref(20)
const jobs = computed(() => data.value?.jobs || [])
const categoryFacets = computed(() => data.value?.categoryFacets || [])
const experienceFacets = computed(() => data.value?.experienceFacets || [])
const locationFacets = computed(() => data.value?.locationFacets || [])
const locationOptionFacets = computed(() => data.value?.locationOptionFacets || [])
const loading = computed(() => status.value === 'pending')

const fetchJobs = async () => {
  const res = await searchJobs({
    page: page.value,
    ...selectedFacetFiltersFromQuery.value,
  })

  return res.data?.searchJobs
}

const newsletterSignupIndex = computed(() => {
  return Math.min(jobs.value.length - 1, 7)
})

const { data, refresh, status } = useLazyAsyncData('jobs-list', async () => await fetchJobs())
watch(
  () => route.query,
  () => refresh(),
)
</script>
